import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    id: 1,
    title: '我独自升级',
    subtitle: '全网热度第一 · 评分 4.9',
    description: 'E级猎人成振宇获得神秘"系统"，开启独一无二的升级之路',
    link: '/comic/i-alone-level-up',
    cta: '立即阅读',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stunning%20cinematic%20comic%20art%20style%20banner%2C%20dramatic%20lighting%20with%20dark%20moody%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20rich%20deep%20colors%20with%20warm%20accents%2C%20abstract%20artistic%20composition%2C%20digital%20illustration%20style%2C%20no%20text%2C%20high%20contrast%2C%20cinematic%20composition&width=1920&height=800&seq=hero-slide-01&orientation=landscape',
  },
  {
    id: 2,
    title: '神之塔',
    subtitle: '奇幻史诗巨作 · 评分 4.8',
    description: '少年二十五夜为追寻挚友进入神秘巨塔，每层都是残酷试炼',
    link: '/comic/tower-of-god',
    cta: '开始探索',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20magical%20tower%20rising%20into%20the%20sky%2C%20fantasy%20cinematic%20style%2C%20dramatic%20golden%20lighting%2C%20Korean%20webtoon%20aesthetic%2C%20epic%20scale%2C%20warm%20amber%20and%20dark%20tones%2C%20digital%20painting%2C%20atmospheric%2C%20no%20text%2C%20cinematic%20composition&width=1920&height=800&seq=hero-slide-02&orientation=landscape',
  },
  {
    id: 3,
    title: '甜蜜家园',
    subtitle: 'Netflix 热门改编 · 评分 4.7',
    description: '在怪物横行的末世公寓中，人类欲望与生存本能的终极考验',
    link: '/comic/sweet-home',
    cta: '进入阅读',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20apocalyptic%20apartment%20building%20atmosphere%2C%20moody%20horror%20cinematic%20style%2C%20Korean%20webtoon%20aesthetic%2C%20deep%20shadows%20with%20red%20accents%2C%20suspenseful%20mood%2C%20digital%20illustration%2C%20no%20text%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=1920&height=800&seq=hero-slide-03&orientation=landscape',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative h-[520px] md:h-[640px] w-full overflow-hidden" aria-label="精选推荐">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-all duration-1000 ${
            index === current ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
          }`}
        >
          <img
            src={slide.imageUrl}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 w-full">
          <div className="max-w-2xl">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-white text-xs font-semibold mb-5 whitespace-nowrap">
              {slides[current].subtitle}
            </span>
            <h1 className="text-4xl md:text-6xl font-heading font-bold text-white mb-5 leading-tight">
              {slides[current].title}
            </h1>
            <p className="text-white/70 text-base md:text-lg mb-8 leading-relaxed max-w-lg">
              {slides[current].description}
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <Link
                to={slides[current].link}
                className="px-7 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                {slides[current].cta}
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to={`/category/action`}
                className="px-7 py-3 bg-white/15 text-white rounded-full text-sm font-semibold hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                浏览更多
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === current ? 'bg-white w-8' : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`切换到第 ${index + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}